import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/chargeStandard/list',
    method: 'post',
    data: data
  });
}
export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/chargeStandard/delete',
    method: 'post',
    data: data
  });
}
export function getDetail(data) {
  return request({
    url: '/pmsservice/api/chargeStandard/get',
    method: 'post',
    data: data
  });
}
export function insert(data) {
  return request({
    url: '/pmsservice/api/chargeStandard/insert',
    method: 'post',
    data: data
  });
}
export function update(data) {
  return request({
    url: '/pmsservice/api/chargeStandard/update',
    method: 'post',
    data: data
  });
}